export enum userTypes {
    UPDATE_USER_CONNECTE = "UPDATE_USER_CONNECTE"
}
  
export default userTypes;